var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0C20.5449 0 22 1.45507 22 3.25V18.75C22 20.5449 20.5449 22 18.75 22H3.25C1.45507 22 0 20.5449 0 18.75V3.25C0 1.45507 1.45507 0 3.25 0H18.75ZM19.3326 20.4007L11.5259 12.7207C11.2606 12.4597 10.8495 12.436 10.5577 12.6495L10.474 12.7207L2.66643 20.4003C2.84895 20.4649 3.04537 20.5 3.25 20.5H18.75C18.9542 20.5 19.1503 20.465 19.3326 20.4007L11.5259 12.7207L19.3326 20.4007ZM18.75 1.5H3.25C2.2835 1.5 1.5 2.2835 1.5 3.25V18.75C1.5 18.958 1.5363 19.1576 1.6029 19.3427L9.42211 11.6513C10.256 10.831 11.5697 10.792 12.4493 11.5342L12.5779 11.6514L20.3971 19.3427C20.4637 19.1576 20.5 18.958 20.5 18.75V3.25C20.5 2.2835 19.7165 1.5 18.75 1.5ZM15.5 4.5C16.8807 4.5 18 5.61929 18 7C18 8.38071 16.8807 9.5 15.5 9.5C14.1193 9.5 13 8.38071 13 7C13 5.61929 14.1193 4.5 15.5 4.5ZM15.5 6C14.9477 6 14.5 6.44772 14.5 7C14.5 7.55228 14.9477 8 15.5 8C16.0523 8 16.5 7.55228 16.5 7C16.5 6.44772 16.0523 6 15.5 6Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.72255a7a12c728cbf31b9bbff39b3bee.svg";
export { ForwardRef as ReactComponent };